import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './TelaBloqueio.css';

const TEXTOS = {
    aguardando: {
        icone: '…',
        titulo: 'Seu acesso está aguardando liberação',
        texto: 'Você entrou com sua conta corporativa, mas ainda não faz parte de nenhum grupo. '
            + 'Nenhum dado é exibido até a liberação.',
    },
    inativo: {
        icone: '!',
        titulo: 'Seu acesso está inativo',
        texto: 'Sua conta foi desativada neste sistema. O histórico continua guardado; para voltar a '
            + 'usar, peça a reativação.',
    },
    sem_token: {
        icone: '!',
        titulo: 'Não foi possível confirmar seu acesso',
        texto: 'Sua sessão não trouxe a autorização para os dados do sistema. Entre novamente para '
            + 'renová-la.',
    },
    sem_acesso: {
        icone: '!',
        titulo: 'Você não tem acesso a esta tela',
        texto: 'Seu perfil não inclui esta tela, ou os dados pedidos estão fora do seu recorte.',
    },
};

/**
 * O que a pessoa vê quando não pode ver o sistema (spec 20261019-gestao-de-acessos, RF02 e
 * RF10). Página inteira para quem está bloqueado; dentro da área de conteúdo para "sem acesso
 * a esta tela"; e como prévia, sem ações, na aba "Telas de bloqueio" da página Acessos.
 */
const TelaBloqueio = ({ tipo, contato, onSair, onRenovar, paginaInteira, previa }) => {
    const t = TEXTOS[tipo] || TEXTOS.sem_acesso;
    const alerta = tipo !== 'aguardando';
    return (
        <div className={`bloqueio${paginaInteira ? ' bloqueio--pagina' : ''}`} role={previa ? undefined : 'alert'}>
            <div className="bloqueio__cartao">
                <div className={`bloqueio__icone${alerta ? ' bloqueio__icone--alerta' : ''}`} aria-hidden="true">{t.icone}</div>
                <h2 className="bloqueio__titulo">{t.titulo}</h2>
                <p className="bloqueio__texto">{t.texto}</p>
                {(tipo === 'aguardando' || tipo === 'inativo') && contato && (
                    <p className="bloqueio__contato">Fale com o administrador: <b>{contato}</b></p>
                )}
                <div className="bloqueio__acoes">
                    {tipo === 'sem_acesso' && (previa
                        ? <span className="bloqueio__botao">Voltar ao início</span>
                        : <Link to="/" className="bloqueio__botao">Voltar ao início</Link>)}
                    {tipo === 'sem_token' && (
                        <button type="button" className="bloqueio__botao" onClick={onRenovar} disabled={previa}>
                            Entrar novamente
                        </button>
                    )}
                    {tipo !== 'sem_acesso' && onSair && (
                        <button type="button" className="bloqueio__botao bloqueio__botao--secundario" onClick={onSair}
                            disabled={previa}>
                            Sair
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

TelaBloqueio.propTypes = {
    tipo: PropTypes.oneOf(['aguardando', 'inativo', 'sem_token', 'sem_acesso']).isRequired,
    contato: PropTypes.string,
    onSair: PropTypes.func,
    onRenovar: PropTypes.func,
    paginaInteira: PropTypes.bool,
    previa: PropTypes.bool,
};

export default TelaBloqueio;
